module.exports = __webpack_public_path__ + "static/media/HCRA Compliance Order - Midland Homes and Development - April 12, 2023_2.592370a4.pdf";